import qpiatoLogo from "@/assets/qpiato.png";

export const AppUpdateRequired = () => {
  return (
    <div className="min-h-[100dvh] bg-[#050a18] flex items-center justify-center px-6 py-8 overflow-hidden relative">
      {/* Animated aurora background */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 80% 50% at 50% -20%, rgba(56, 189, 248, 0.15) 0%, transparent 60%), radial-gradient(ellipse 60% 40% at 80% 50%, rgba(139, 92, 246, 0.12) 0%, transparent 50%), radial-gradient(ellipse 50% 30% at 20% 80%, rgba(6, 182, 212, 0.1) 0%, transparent 50%), radial-gradient(ellipse 40% 40% at 50% 100%, rgba(99, 102, 241, 0.08) 0%, transparent 50%)",
            animation: "aurora 8s ease-in-out infinite alternate",
          }}
        />
      </div>

      {/* Scan lines */}
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.05) 2px, rgba(255,255,255,0.05) 4px)",
        }}
      />

      {/* Perspective grid floor */}
      <div
        className="absolute bottom-0 left-0 right-0 h-[40%] opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(56,189,248,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(56,189,248,0.4) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
          transform: "perspective(500px) rotateX(60deg)",
          transformOrigin: "bottom center",
          maskImage: "linear-gradient(to top, white 30%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to top, white 30%, transparent 100%)",
        }}
      />

      {/* Moving light beam */}
      <div
        className="absolute top-0 w-px h-full opacity-[0.06] pointer-events-none"
        style={{
          background:
            "linear-gradient(to bottom, transparent, rgba(56,189,248,0.8) 50%, transparent)",
          animation: "beam-sweep 6s ease-in-out infinite",
        }}
      />

      <style>{`
        @keyframes aurora {
          0% { transform: scale(1) translateY(0); filter: hue-rotate(0deg); }
          100% { transform: scale(1.1) translateY(-5%); filter: hue-rotate(20deg); }
        }
        @keyframes beam-sweep {
          0%, 100% { left: -10%; opacity: 0; }
          10% { opacity: 0.06; }
          50% { opacity: 0.06; }
          90% { opacity: 0.06; }
          0% { left: -10%; }
          100% { left: 110%; }
        }
        @keyframes logo-float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        @keyframes card-glow {
          0%, 100% { box-shadow: 0 0 20px rgba(56, 189, 248, 0.03), inset 0 0 20px rgba(56, 189, 248, 0.02); }
          50% { box-shadow: 0 0 40px rgba(56, 189, 248, 0.08), inset 0 0 30px rgba(139, 92, 246, 0.03); }
        }
      `}</style>

      <div className="w-full max-w-sm text-center space-y-6 relative z-10">
        {/* Logo with glow + float */}
        <div
          className="relative inline-block"
          style={{ animation: "logo-float 4s ease-in-out infinite" }}
        >
          <div className="absolute -inset-8 blur-3xl bg-sky-500/10 rounded-full" />
          <div className="absolute -inset-4 blur-xl bg-violet-500/5 rounded-full" />
          <img
            src={qpiatoLogo}
            alt="Qpiato"
            className="relative mx-auto w-40 max-h-[30dvh] object-contain"
            style={{
              filter:
                "drop-shadow(0 0 20px rgba(56,189,248,0.2)) drop-shadow(0 0 40px rgba(139,92,246,0.1))",
            }}
          />
        </div>

        {/* Title */}
        <div>
          <h1 className="text-xl font-semibold text-white tracking-wide">
            A New Experience Awaits!
          </h1>
          <p className="text-sm text-gray-400 mt-0.5">
            Uma nova experiencia espera por si!
          </p>
        </div>

        {/* Glowing card */}
        <div
          className="relative backdrop-blur-md bg-white/[0.03] rounded-2xl px-5 py-4 space-y-3 text-sm border border-white/[0.06] overflow-hidden"
          style={{ animation: "card-glow 5s ease-in-out infinite" }}
        >
          {/* Card inner highlight */}
          <div
            className="absolute top-0 left-0 right-0 h-px"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(56,189,248,0.3), rgba(139,92,246,0.2), transparent)",
            }}
          />
          <p className="text-gray-300/90">
            We've built a better version of Qpiato.
            <br />
            <span className="text-gray-500">
              Contact our team to upgrade.
            </span>
          </p>
          <div className="h-px bg-gradient-to-r from-transparent via-sky-500/20 to-transparent" />
          <p className="text-gray-300/90">
            Construimos uma versao melhor do Qpiato.
            <br />
            <span className="text-gray-500">
              Contacte a nossa equipa para fazer upgrade.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
